<template>
  <div class="min-h-screen flex flex-col">
    <WebHeader @form-select="showForm" />
    <main class="flex-grow">
      <HeroSection />
       <PatientRecruitmentForm />
      <!-- 数据滚动展示区 -->
      <section class="data-stats-section">
        <div class="container">
          <div class="stats-grid">
            <DataCounter label="年承接项目量" target="200" />
            <DataCounter label="合作临床研究中心" target="400" />
            <DataCounter label="合作医生量" target="33000" />
            <DataCounter label="患者量" target="165000" />
            <DataCounter label="覆盖区域量" target="440" />
          </div>
        </div>
      </section>
      <CompanyInfo />
      <CompanyFeatures />
      <CompanyCulture />
      <TeamShowcase />
      
      <!-- Testimonials Section -->
      <section class="testimonials-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">患者心声</h2>
            <div class="title-underline"></div>
          </div>
          
          <div class="testimonials-grid">
            <div class="testimonial-card">
              <div class="patient-info">
                <img 
                  src="https://space.coze.cn/api/coze_space/gen_image?image_size=square&prompt=Patient%20portrait%20middle-aged%20woman%20smiling&sign=ea6ba8f113ff3dbf3c5286324fbdcc4c" 
                  alt="患者头像" 
                  class="patient-avatar"
                />
                <div class="patient-details">
                  <h4 class="patient-name">王女士</h4>
                  <div class="rating">
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                  </div>
                </div>
              </div>
              <p class="testimonial-content">
                "感谢安徽经纶瑞恒医药科技有限公司的临床试验项目，给了我新的治疗机会。这里的医生专业且富有同情心，
                让我在治疗过程中感受到了温暖和希望。"
              </p>
            </div>
            
            <div class="testimonial-card">
              <div class="patient-info">
                <img 
                  src="https://space.coze.cn/api/coze_space/gen_image?image_size=square&prompt=Patient%20portrait%20elderly%20man%20smiling&sign=ee6deee8649cba03cecbb642a1a47515" 
                  alt="患者头像" 
                  class="patient-avatar"
                />
                <div class="patient-details">
                  <h4 class="patient-name">张先生</h4>
                  <div class="rating">
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star-half-stroke"></i>
                  </div>
                </div>
              </div>
              <p class="testimonial-content">
                "作为一名慢性病患者，我参加了安徽经纶瑞恒医药科技有限公司的研究项目。他们的医疗团队不仅提供了先进的治疗方案，
                还给予了我全方位的健康管理指导，我的生活质量得到了显著改善。"
              </p>
            </div>
            
            <div class="testimonial-card">
              <div class="patient-info">
                <img 
                  src="https://space.coze.cn/api/coze_space/gen_image?image_size=square&prompt=Patient%20portrait%20young%20man%20smiling&sign=4ec3d56ad1b1e56eff9927823a1f3aa7" 
                  alt="患者头像" 
                  class="patient-avatar"
                />
                <div class="patient-details">
                  <h4 class="patient-name">李先生</h4>
                  <div class="rating">
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                    <i class="fa-solid fa-star"></i>
                  </div>
                </div>
              </div>
              <p class="testimonial-content">
                "安徽经纶瑞恒医药科技有限公司的多学科协作诊疗模式给我留下了深刻印象。不同领域的专家共同为我制定治疗方案，
                让我感受到了最全面、最专业的医疗服务。"
              </p>
            </div>
          </div>
        </div>
      </section>
        <SystemSetupForm />
      <!-- 表单区域 -->
      <!-- <section id="recruitment" class="form-section">
      
      </section> -->
    </main>
    <WebFooter />
    <!-- 微信添加组件 -->
    <div class="wechat-container">
      <div class="wechat-wrapper" @click="showWechatModal">
        <div class="wechat-content">
          <i class="fa-brands fa-weixin wechat-icon"></i>
          <p class="wechat-text">点击添加微信</p>
        </div>
      </div>
    </div>
    
    <!-- 微信弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>添加微信</h3>
          <button class="close-button" @click="closeModal">&times;</button>
        </div>
        <div class="modal-body">
          <p>微信号：{{ wechatId }}</p>
          <p class="modal-description">点击下方按钮复制微信号，然后在微信中搜索并添加好友</p>
        </div>
        <div class="modal-footer">
          <button class="copy-button" @click="copyWechatId">复制微信号</button>
          <button class="close-button-secondary" @click="closeModal">关闭</button>
        </div>
      </div>
    </div>
    
    <!-- 复制成功提示 -->
    <div v-if="showCopySuccess" class="copy-success-toast">
      微信号已复制到剪贴板！
    </div>
  </div>
</template>
<script setup>
// 使用 setup 语法糖的导入方式
import WebHeader from '@/components/WebHeader.vue'
import WebFooter from '@/components/WebFooter.vue'
import HeroSection from '@/components/HeroSection.vue'
import CompanyInfo from '@/components/CompanyInfo.vue'
import CompanyFeatures from '@/components/CompanyFeatures.vue'
import CompanyCulture from '@/components/CompanyCulture.vue'
import PatientRecruitmentForm from '@/components/PatientRecruitmentForm.vue'
import SystemSetupForm from '@/components/SystemSetupForm.vue'
import DataCounter from '@/components/DataCounter.vue'
import TeamShowcase from '@/components/TeamShowcase.vue'
import { ref } from 'vue'

const currentForm = ref('')
const showModal = ref(false)
const showCopySuccess = ref(false)
const wechatId = ref('13721076171') // 这里替换为实际的微信号

const showForm = (formType) => {
  currentForm.value = formType
  // 滚动到表单区域
  setTimeout(() => {
    const element = document.getElementById('recruitment')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }, 100)
}

const showWechatModal = () => {
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
}

const copyWechatId = () => {
  // 创建一个临时的input元素
  const tempInput = document.createElement('input')
  tempInput.value = wechatId.value
  document.body.appendChild(tempInput)
  tempInput.select()
  document.execCommand('copy')
  document.body.removeChild(tempInput)
  
  // 显示复制成功提示
  showCopySuccess.value = true
  
  // 3秒后隐藏提示
  setTimeout(() => {
    showCopySuccess.value = false
  }, 3000)
}
</script>

<style scoped>
/* 基础样式重置 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  line-height: 1.6;
  color: #333;
}

/* 容器样式 - 响应式核心 */
.container {
  width: 100%;
  padding-right: 1rem;
  padding-left: 1rem;
  margin-right: auto;
  margin-left: auto;
}

/* 响应式断点设置 */
/* 超小屏幕 - 手机 (<576px) */
@media (max-width: 575.98px) {
  .container {
    max-width: 100%;
  }
}

/* 小屏幕 - 平板 (≥576px) */
@media (min-width: 576px) and (max-width: 767.98px) {
  .container {
    max-width: 540px;
  }
}

/* 中等屏幕 - 小笔记本 (≥768px) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .container {
    max-width: 720px;
  }
}

/* 大屏幕 - 笔记本/台式机 (≥992px) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .container {
    max-width: 960px;
  }
}

/* 超大屏幕 (≥1200px) */
@media (min-width: 1200px) {
  .container {
    max-width: 1280px;
  }
}

/* 数据统计区域 */
.data-stats-section {
  padding: 4rem 0;
  position: relative;
  overflow: hidden;
  background-color: #f9fafb;
}

.stats-grid {
  display: grid;
  gap: 1.5rem;
  text-align: center;
}

/* 响应式网格布局 */
@media (max-width: 575.98px) {
  .stats-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (min-width: 576px) and (max-width: 991.98px) {
  .stats-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 992px) {
  .stats-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

/* 患者心声区域 */
.testimonials-section {
  padding: 5rem 0;
  background-color: #eff6ff;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title {
  font-size: clamp(1.5rem, 3vw, 2.25rem); /* 响应式字体大小 */
  font-weight: 700;
  color: #111827;
  margin-bottom: 1rem;
}

.title-underline {
  width: 5rem;
  height: 0.25rem;
  background-color: #2563eb;
  margin: 0 auto;
  border-radius: 9999px;
}

.testimonials-grid {
  display: grid;
  gap: 2rem;
}

/* 响应式 testimonial 网格 */
@media (max-width: 767.98px) {
  .testimonials-grid {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 768px) and (max-width: 1199.98px) {
  .testimonials-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1200px) {
  .testimonials-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.testimonial-card {
  background-color: white;
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  height: 100%; /* 确保卡片高度一致 */
  display: flex;
  flex-direction: column;
}

.patient-info {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.patient-avatar {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 1rem;
}

.patient-details {
  flex: 1;
}

.patient-name {
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.25rem;
}

.rating {
  display: flex;
  color: #fbbf24;
}

.testimonial-content {
  color: #374151;
  font-style: italic;
  line-height: 1.6;
  flex-grow: 1;
}

/* 表单区域样式 */
.form-section {
  padding: 3rem 1rem;
}

/* 微信组件样式 */
.wechat-container {
  position: fixed;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
  z-index: 1000;
  cursor: pointer;
}

.wechat-wrapper {
  background: #1aad19; /* 微信绿色 */
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 15px;
  text-align: center;
  max-width: 120px;
  transition: all 0.3s ease;
}

.wechat-wrapper:hover {
  background: #169817; /* 悬停时稍微加深颜色 */
  transform: scale(1.05);
}

.wechat-icon {
  font-size: 32px;
  color: white;
  margin-bottom: 8px;
}

.wechat-text {
  font-size: 12px;
  color: white;
  line-height: 1.4;
  margin: 0;
  font-weight: 500;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-content {
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 10px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
  text-align: center;
}

.modal-body p {
  margin: 10px 0;
  font-size: 16px;
  color: #555;
}

.modal-body p:first-child {
  font-weight: bold;
  font-size: 18px;
  color: #1aad19;
}

.modal-description {
  font-size: 14px !important;
  color: #888 !important;
  margin-top: 15px !important;
}

.modal-footer {
  display: flex;
  padding: 15px 20px 20px;
  gap: 10px;
}

.copy-button, .close-button-secondary {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.copy-button {
  background-color: #1aad19;
  color: white;
}

.copy-button:hover {
  background-color: #169817;
}

.close-button-secondary {
  background-color: #f1f1f1;
  color: #333;
}

.close-button-secondary:hover {
  background-color: #ddd;
}

/* 复制成功提示 */
.copy-success-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 15px 25px;
  border-radius: 5px;
  z-index: 3000;
  font-size: 16px;
  animation: toastFadeIn 0.3s, toastFadeOut 0.3s 2.7s;
}

@keyframes toastFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes toastFadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

/* 移动端优化 */
@media (max-width: 575.98px) {
  .data-stats-section {
    padding: 2rem 0;
  }
  
  .testimonials-section {
    padding: 3rem 0;
  }
  
  .testimonial-card {
    padding: 1rem;
  }
  
  .form-section {
    padding: 2rem 0.5rem;
  }
  
  .wechat-container {
    right: 40px;
  }
  
  .wechat-wrapper {
    max-width: 100px;
    padding: 10px;
  }
  
  .wechat-icon {
    font-size: 24px;
  }
  
  .wechat-text {
    font-size: 10px;
  }
  
  .modal-content {
    width: 95%;
  }
  
  .modal-header, .modal-body, .modal-footer {
    padding: 15px;
  }
  
  .modal-footer {
    flex-direction: column;
  }
}

@media (max-width: 375px) {
  .wechat-container {
    display: none;
  }
}
</style>